import { Link } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import Seo from "@/components/feature/Seo";

export default function NotFound() {
  return (
    <Layout>
      <Seo
        title="页面未找到 | 漫蛙漫画网"
        description="你访问的页面不存在或已被移除，欢迎返回漫蛙漫画网首页继续追更。"
      />
      <div className="flex min-h-[70vh] flex-col items-center justify-center px-4 py-24 text-center">
        <p className="font-heading text-8xl font-extrabold text-primary-100 select-none">404</p>
        <h1 className="mt-4 font-heading text-2xl font-extrabold text-foreground-950">
          这一话似乎消失了
        </h1>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-500">
          你访问的页面不存在或已被移除。别担心，精彩的作品仍在漫蛙漫画网等你来追。
        </p>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <Link
            to="/"
            className="whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            返回首页
          </Link>
          <Link
            to="/works"
            className="whitespace-nowrap rounded-full bg-background-100 px-7 py-3 text-sm font-semibold text-primary-700 ring-1 ring-primary-200 transition-colors hover:bg-primary-100"
          >
            浏览作品列表
          </Link>
        </div>
      </div>
    </Layout>
  );
}